module.exports = __webpack_public_path__ + "b0b02c4200e290c3e81bed87893fe38a.pdf";